import i18next from 'i18next';
import moment from 'moment';
import 'moment/locale/fr';

const DEFAULT_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSSZ';

/**
 * long
 * en-US: MMMM D, YYYY - July 13, 2025
 * fr-CA D MMMM, YYYY - 13 Juillet 2025
 *
 * longWithMonthName
 * en-US: MMMM Do, YYYY - July 13th, 2025
 * fr-CA: Do MMMM, YYYY - 13th Juil, 2025
 *
 * short
 * en-US: MM/DD/YYYY - 07/13/2025
 * fr-CA: DD/MM/YYYY - 13/07/2025
 *
 * shortDash
 * en-US: MM-DD-YYYY
 * fr-CA: DD-MM-YYYY
 *
 * shortWithMonthName
 * en-US: MMM DD, YYYY - Jul 13, 2025
 * fr-CA: DD MMM, YYYY - 13 Juil, 2025
 *
 * @constant {Object} DATE_FORMATS
 */
const DATE_FORMATS = {
  long: 'common:dateFormats.fullMonthAndYear',
  longWithMonthName: 'common:dateFormats.longMonthAndYear',
  short: 'common:dateFormats.short',
  shortDash: 'common:dateFormats.shortDash',
  shortWithMonthName: 'common:dateFormats.shortMonthAndYear',
};

const formatDateByLanguage = ({
  date,
  dateFormat = DATE_FORMATS.long,
}) => {
  if (!date) {
    return date;
  }

  const currentLanguage = i18next.language.split('-')[0];
  const format = i18next.t(dateFormat);
  // set the language to all of the instances right
  // before create and format new dates
  moment.locale(currentLanguage);
  const formatted = moment(date, DEFAULT_FORMAT).format(format);

  return formatted;
};

/**
* Short date format based on language
 *
 * @param {*} date string date YYYY-MM-DDTHH:mm:ss.SSSZ
 * @returns formatted date string MM/DD/YYYY or DD/MM/YYYY or 'N/A'
 */
const formatShortDateByLanguage = (date) => {
  const value = formatDateByLanguage({
    date,
    dateFormat: DATE_FORMATS.short,
  });

  return value || i18next.t('common:dateFormats.na');
};

/**
* Short date format based on language
 *
 * @param {*} date string date YYYY-MM-DDTHH:mm:ss.SSSZ
 * @returns formatted date string MM/DD/YYYY or DD/MM/YYYY or 'N/A'
 */
const formatShortDashDateByLanguage = (date) => {
  const value = formatDateByLanguage({
    date,
    dateFormat: DATE_FORMATS.shortDash,
  });

  return value || i18next.t('common:dateFormats.na');
};

export {
  DATE_FORMATS,
  formatDateByLanguage,
  formatShortDashDateByLanguage,
  formatShortDateByLanguage,
};
